export default class MyDocumentsAbstractServices {
  static getMyDocumentsReferenceData() {
    logger.error(`My Documents:: getMyDocumentsReferenceData() not implemented`);
  }

  static getDocumentSummary(memberNumber) {
    logger.error(`My Documents:: getDocumentSummary(${memberNumber}) not implemented`);
  }

  static getDocumentFile(memberNumber, accessingPersonCode, documentId) {
    logger.error(`My Documents:: getDocumentFile( ${memberNumber},${accessingPersonCode}, ${documentId}) not implemented`);
  }
}